import React from "react";
import { Box, Chip, IconButton, Paper, Typography } from "@mui/material";
import { Edit, NoteAlt } from "@mui/icons-material";
import dayjs from "dayjs";
import type { UpcomingTrainingDate } from "./types";

interface UpcomingSessionCardProps {
  date: UpcomingTrainingDate;
  onEditNotes: (date: UpcomingTrainingDate) => void;
}

const UpcomingSessionCard: React.FC<UpcomingSessionCardProps> = ({
  date,
  onEditNotes,
}) => {
  const isSoon = date.days_until <= 2;
  const label =
    date.days_until === 0
      ? "Today"
      : date.days_until === 1
        ? "Tomorrow"
        : `In ${date.days_until} days`;

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 1.5,
        borderRadius: 2,
        borderColor: isSoon ? "warning.main" : "success.main",
        bgcolor: isSoon ? "warning.light" : "success.light",
        opacity: 0.9,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {dayjs(date.training_date).format("ddd DD MMM, HH:mm")}
        </Typography>
        <IconButton
          size="small"
          title="Add / edit notes"
          onClick={() => onEditNotes(date)}
          sx={{ ml: 0.5, mt: -0.5 }}
        >
          <Edit fontSize="inherit" />
        </IconButton>
      </Box>
      <Chip
        label={label}
        size="small"
        color={isSoon ? "warning" : "success"}
        sx={{ mt: 0.5, fontWeight: 600 }}
      />
      {date.notes && (
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 0.5,
            mt: 1,
          }}
        >
          <NoteAlt
            fontSize="inherit"
            sx={{
              mt: "2px",
              color: "text.secondary",
              flexShrink: 0,
            }}
          />
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ lineHeight: 1.4 }}
          >
            {date.notes}
          </Typography>
        </Box>
      )}
    </Paper>
  );
};

export default UpcomingSessionCard;
